import { LoggerModule } from 'i18next'
import { logger, LogContext } from '../../../helpers/logger'

// i18next logs every missing key and init step, keep that at debug and only surface real problems
const formatArgs = (args: unknown[]) => args.map((arg) => (typeof arg === 'string' ? arg : JSON.stringify(arg))).join(' ')

export const loggerPlugin: LoggerModule = {
  type: 'logger',
  log: (args: unknown[]) => logger.debug(LogContext.I18N, formatArgs(args)),
  warn: (args: unknown[]) => logger.warn(LogContext.I18N, formatArgs(args)),
  error: (args: unknown[]) => logger.error(LogContext.I18N, formatArgs(args)),
}
